import { render, staticRenderFns } from "./UpsellItem.vue?vue&type=template&id=4d450c9f&scoped=true"
import script from "./UpsellItem.vue?vue&type=script&lang=js"
export * from "./UpsellItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d450c9f",
  null
  
)

export default component.exports